export default __webpack_public_path__ + "static/media/pixels-project-6.21b5b5ec.jpg";